import { render, staticRenderFns } from "./LineReserveTimes.vue?vue&type=template&id=10720a5c"
import script from "./LineReserveTimes.vue?vue&type=script&lang=js"
export * from "./LineReserveTimes.vue?vue&type=script&lang=js"
import style0 from "./LineReserveTimes.vue?vue&type=style&index=0&id=10720a5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports